import { useEffect, useState } from 'react'
import { Card, FlexItem, ListItem, Text } from 'components/Library'
import dayjs from 'dayjs'

import { useSelector } from 'react-redux'

const RecentClients = () => {
  const { clientesRecientes } = useSelector((state) => state.analytics)
  const [datosGrafico, setDatosGrafico] = useState([])

  useEffect(() => {
    if (clientesRecientes.length > 0) {
      const datos = clientesRecientes.slice(0, 5)
      setDatosGrafico(datos)
    }
  }, [clientesRecientes])

  return (
    <Card style={{ padding: '2rem', width: '100%' }}>
      <Text weight="bold">Clientes recientes</Text>
      {datosGrafico.map((cliente) => (
        <ListItem
          key={cliente.id}
          style={{
            display: 'flex',
            gridGap: '1rem',
            paddingTop: '1rem'
          }}
        >
          {/* <span
            style={{
              backgroundColor: colors.primary,
              color: "white",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              borderRadius: "2rem",
              width: "40px",
              height: "40px",
            }}
          >
            <img
              style={{
                borderRadius: "2rem",
                width: "40px",
                height: "40px",
              }}
              src={cliente.idioma}
              alt={cliente.idioma}
            />
          </span> */}
          <FlexItem
            alignItems="center"
            flexDirection="row"
            style={{
              padding: '0',
              flex: 'auto'
            }}
          >
            <FlexItem
              flexDirection="column"
              style={{
                padding: 0,
                placeItems: 'flex-start'
              }}
            >
              <Text weight="bold">{cliente?.nombre}</Text>
              <Text size="small">{cliente?.correo?.toLowerCase()}</Text>
              <Text size="small">{cliente?.telefono}</Text>
            </FlexItem>
            <Text size="small">{cliente.fecha && dayjs(cliente.fecha).format('DD/MMM/YYYY')}</Text>
          </FlexItem>
        </ListItem>
      ))}
    </Card>
  )
}

export default RecentClients
